(function () {
  if (customElements.get("m-diag")) return;
  class MDiag extends HTMLElement {
    connectedCallback() {
      this.licenses = Array.from(this.querySelectorAll("[data-lic]"));
      this.totalEl = this.querySelector("[data-total]");
      this.atc = this.querySelector("[data-atc]");
      this.errEl = this.querySelector("[data-error]");
      this.mainImg = this.querySelector("[data-main-img]");
      this.thumbs = Array.from(this.querySelectorAll("[data-thumb]"));
      this.cartUrl = this.dataset.cartUrl || "/cart";
      this.variant = 0;

      this.licenses.forEach((el) => {
        el.addEventListener("click", () => this._selectLicense(el));
        el.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this._selectLicense(el); }
        });
      });
      this.thumbs.forEach((t) => t.addEventListener("click", () => this._swap(t)));
      if (this.atc) this.atc.addEventListener("click", () => this._add());

      const def = this.querySelector("[data-lic][data-default]") || this.licenses[0];
      if (def) this._selectLicense(def);

      this._initReveal();
      this._initChapter();
    }

    _initChapter() {
      const panels = Array.from(this.querySelectorAll("[data-panel]"));
      const slots = Array.from(this.querySelectorAll("[data-media-slot]"));
      if (panels.length < 2) return;
      const setActive = (i) => {
        panels.forEach((p, idx) => p.classList.toggle("is-active", idx === i));
        slots.forEach((s, idx) => s.classList.toggle("is-on", idx === i));
      };
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(parseInt(e.target.dataset.panel, 10));
        });
      }, { rootMargin: "-48% 0px -48% 0px", threshold: 0 });
      panels.forEach((p) => io.observe(p));
    }

    _initReveal() {
      const els = Array.from(this.querySelectorAll("[data-reveal]"));
      if (!els.length) return;
      const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce || !("IntersectionObserver" in window)) {
        els.forEach((el) => el.classList.add("is-in"));
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
      els.forEach((el) => io.observe(el));
    }

    _selectLicense(el) {
      this.licenses.forEach((x) => {
        const on = x === el;
        x.classList.toggle("is-on", on);
        x.setAttribute("aria-checked", on ? "true" : "false");
      });
      this.variant = parseInt(el.dataset.varId, 10);
      if (this.totalEl) this.totalEl.textContent = el.dataset.priceTxt || "";
      if (this.errEl) this.errEl.textContent = "";
    }

    _swap(t) {
      const src = t.dataset.full;
      if (src && this.mainImg) {
        this.mainImg.src = src;
        if (t.dataset.alt !== undefined) this.mainImg.alt = t.dataset.alt;
      }
      this.thumbs.forEach((x) => x.classList.toggle("is-on", x === t));
    }

    async _add() {
      if (!this.variant) return;
      this.atc.disabled = true;
      this.atc.classList.add("is-loading");
      const item = { id: this.variant, quantity: 1 };
      if (this.dataset.propName && this.dataset.propValue) {
        item.properties = { [this.dataset.propName]: this.dataset.propValue };
      }
      try {
        const r = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [item] }),
        });
        if (!r.ok) throw new Error("add failed");
        window.location.href = this.cartUrl;
      } catch (e) {
        this.atc.disabled = false;
        this.atc.classList.remove("is-loading");
        if (this.errEl) this.errEl.textContent = this.dataset.errText || "Konnte nicht hinzugefügt werden.";
      }
    }
  }
  customElements.define("m-diag", MDiag);
})();
